/**
    商品列表
**/
<template>
     <div class="header_logo">
        <el-menu
             background-color="#ff6700"
             mode="horizontal"
             router
             class="el-menu-vertical-demo">
                 <!-- <el-menu-item><img class="xunyouText" :src="require('@/assets/img/xunyouText.png')" @click="$router.push('/')" alt=""></el-menu-item> -->
                 <el-menu-item><span class="bigtitle" @click="$router.push('/')">{{copyRight.name}}</span></el-menu-item>
                 <el-menu-item v-for="item in leftMenu" :key="item.id" :index="item.url">
                     <template slot="title"><i :class="item.icon"></i>{{item.menu}}</template>                        
                 </el-menu-item>            
         </el-menu>
         <div class="middle">
             <router-view></router-view>
         </div>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
export default {
  data() {
    return {
        leftMenu:[
            {
                id:1,
                menu:'商城首页',
                url:'/',
                icon:'el-icon-s-home'
            },
            {
                id:2,
                menu:'用户中心',
                url:'/userCenter',
                icon:'el-icon-user'
            }, 
            {
                id:3,
                menu:'支付中心',
                url:'/paymentCenter',
                icon:'el-icon-coin'
            },
        ],
    };
  },
   computed:{
    ...mapState(['copyRight'])
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  },
};
</script>

<style scoped lang="less">
.header_logo{
    height: 100%;
    .xunyouText{
        width: 100px;
        height: auto;
    }
    li.el-menu-item {
        color: white !important;
        font-size: 16px;
        i{
            color: white;
            vertical-align: inherit;
        }
    }
    .middle{
        height: 100% !important;
        background: url("~@/assets/img/userCenterbg.jpg") no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
    }

}
.breakcrumbHeader {
  margin: 15px 0;
}
.bigtitle{
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2px;
}


</style>

 
 

 


// WEBPACK FOOTER //
// src/views/siteNavigation/siteNavigation.vue